import { ComponentRef, Directive, ElementRef, HostListener, Input, OnInit, Renderer2, ViewContainerRef } from '@angular/core';
import { PopupComponent } from './popup.component';

@Directive({
  selector: '[appImagePopup]',
  standalone: false
})
export class ImagePopupDirective implements OnInit {
  @Input() popupImageSrc: string; // Input to pass the image source

  private popupComponentRef: ComponentRef<PopupComponent>; // Reference to the popup component

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    private viewContainerRef: ViewContainerRef
  ) { }

  ngOnInit(): void {
    this.el.nativeElement.style = 'cursor:pointer;';
  }

  @HostListener('click', ['$event'])
  onClick(event: MouseEvent) {
    event.preventDefault();
    this.openPopup();
  }

  private openPopup() {
    if (!this.popupComponentRef) {
      this.popupComponentRef = this.viewContainerRef.createComponent(PopupComponent);

      // Pass the image source to the popup component
      this.popupComponentRef.instance.imageSrc = this.el.nativeElement.src.replace('/thumbnails/', '/images/'); //this.popupImageSrc;

      // Append the popup to the body
      document.body.appendChild(this.popupComponentRef.location.nativeElement);

      // Subscribe to the popup's close event
      this.popupComponentRef.instance.close.subscribe(() => this.closePopup());
    }
  }

  private closePopup() {
    if (this.popupComponentRef) {
      this.popupComponentRef.destroy();
      this.popupComponentRef = null;
    }
  }

  ngOnDestroy() {
    if (this.popupComponentRef) {
      this.popupComponentRef.destroy();
      this.popupComponentRef = null;
    }
  }
}
